<template>
  <div>
    <el-page-header @back="goBack" :content="title"></el-page-header>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
      <el-tab-pane label="配置管理" name="second">
        <zx-table
          :tableData="tableData"
          :option="table"
          :page="page"
          @searchSubmit="searchSubmit"
          @handleSelectionChange="handleSelectionChange"
          @delBtn="delBtn"
          @refresh-change="getlist"
          @addSubmit="addSubmit"
          @etidSubmit="etidSubmit"
          @refreshBtn="refreshBtn"
        >
        </zx-table>
      </el-tab-pane>
      <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
      <el-tab-pane label="表单设计" name="from">
        <f-render
          @save="handleSave"
          :loading="loading"
          height="calc(100vh - 220px)"
          :config="formConfig"
          :comps="comps"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import comps from "../assets/from-components/fixtures/comps.js";
import customUrl from "../assets/from-components/fixtures/extends/custom-url.js";
import selectIcon from "../assets/from-components/fixtures/extends/selectIcon.js";
import * as current from "@/api/current.js";
import * as tableDataList from "../assets/testData.js";
import xzTable from "@/components/xz-table.vue";
export default {
  created() {
    this.getlist();
  },
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      comps: comps.concat(customUrl, selectIcon),
      activeName: "second",
      title: "字段编辑",
      table: {
        // 表格底部按钮
        btnBottom: true,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        selection: true,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: false,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: true,
        // 动态列
        hideBtn: false,
        column: [
          {
            // 字段
            prop: "name",
            // 列名
            label: "字段列名",
            // 表单 类型
            type: "input",
            // 是否必须输入
            required: true,
            // 表格是否显示
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: true,
            // 倒叙 默认:false;
            sortable: true,
            // 该字段是否可以在筛选 默认:false;
            searchDisplay: true
          },
          {
            // 字段
            prop: "zd描述",
            // 列名
            label: "字段名描述",
            // 表单 类型
            type: "input",
            // 是否必须输入
            required: true,
            // 表格是否显示
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: true,
            // 倒叙 默认:false;
            sortable: true,
            // 该字段是否可以在筛选 默认:false;
            searchDisplay: true,
            // 表格显示类型 默认文字 支持 下拉框dropdown 输入框 input图片:image; 标签:tag;
            show: "input"
          },
          {
            prop: "cr",
            label: "插入",
            type: "input",
            addDisplay: false,
            show: "checkbox",
            hide: true,
            width: "50"
          },
          {
            prop: "bj",
            label: "编辑",
            type: "input",
            addDisplay: false,
            show: "checkbox",
            hide: true,
            width: "50"
          },
          {
            prop: "lb",
            label: "列表",
            type: "input",
            addDisplay: false,
            show: "checkbox",
            hide: true,
            width: "50"
          },
          {
            prop: "cx",
            label: "查询",
            type: "input",
            addDisplay: false,
            show: "checkbox",
            hide: true,
            width: "50"
          },
          {
            prop: "bt",
            label: "必填",
            type: "input",
            addDisplay: false,
            show: "checkbox",
            hide: true,
            width: "50"
          },
          {
            // 字段
            prop: "name",
            label: "查询方式",
            type: "input",
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 倒叙 默认:false;
            sortable: false,
            // 该字段是否可以在筛选 默认:false;
            searchDisplay: false,
            // 表格显示类型 默认文字 支持 下拉框dropdown 输入框 input图片:image; 标签:tag;
            show: "select",
            selectDataList: [
              {
                label: "姓名",
                value: 1
              },
              {
                label: "姓名1",
                value: 2
              },
              {
                label: "姓名3",
                value: 1
              }
            ]
          },
          {
            // 字段
            prop: "xstype",
            label: "显示类型",
            type: "input",
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 倒叙 默认:false;
            sortable: false,
            // 该字段是否可以在筛选 默认:false;
            searchDisplay: false,
            // 表格显示类型 默认文字 支持 下拉框dropdown 输入框 input图片:image; 标签:tag;
            show: "select",
            selectDataList: [
              {
                label: "姓名",
                value: 1
              },
              {
                label: "姓名1",
                value: 2
              },
              {
                label: "姓名3",
                value: 1
              }
            ]
          },
          {
            // 字段
            prop: "zdtype",
            label: "字典类型",
            type: "input",
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 倒叙 默认:false;
            sortable: false,
            // 该字段是否可以在筛选 默认:false;
            searchDisplay: false,
            // 表格显示类型 默认文字 支持 下拉框dropdown 输入框 input图片:image; 标签:tag;
            show: "select",
            selectDataList: [
              {
                label: "姓名",
                value: 1
              },
              {
                label: "姓名1",
                value: 2
              },
              {
                label: "姓名3",
                value: 1
              }
            ]
          }
        ]
      },
      //
      tableData: tableDataList.infoData,
      searchData: null,
      // 表单数据
      loading: false,
      formConfig: {}
    };
  },
  mounted() {
    this.getformConfig();
  },

  methods: {
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      this.getlist();
    },
    // 多选
    handleSelectionChange(e) {},
    // 添加提交
    addSubmit(form) {
      current.addCurrent.r(form).then(res => {
        this.$message.success("账号" + res.name + "创建成功");
        this.getlist();
      });
    },
    // 编辑
    etidSubmit(form) {
      current.editCurrent.r(form).then(res => {
        this.$message.success("修改成功");
        this.getlist();
      });
    },
    // 删除
    delBtn(form) {
      current.deleteCurrent
        .r({
          id: form.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getlist();
        });
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    async getlist(e) {
      // 	if(e)this.page = e;
      // 	let param = {
      // 		page: this.page.currentPage,
      // 		limit: this.page.pageSize,
      // 	};
      // 	if(this.searchData){
      // 		param = {
      // 			page: this.page.currentPage,
      // 			limit: this.page.pageSize,
      // 			...this.searchData
      // 		}
      // 	}
      // 	let res = await current.request.r(param)
      // 	this.tableData = res.list
      // 	this.page.total = res.total
    },
    // 保存表单
    handleSave(res) {
      // 这里是保存到 localStorage，你可以保存到服务器
      localStorage.setItem("form-config", res);
      this.$message.success("保存成功啦~");
    },
    // 表单获取代码
    getformConfig() {
      // 模拟异步加载
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        // localStorage.getItem("form-config");
        this.formConfig = localStorage.getItem("form-config");
      }, 1000);
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.from-page {
  height: calc(100vh - 230px);
}</style
>>
